import React from "react";

/**
 * BaseModal Component
 * Reusable modal wrapper with overlay, header, body, and footer
 * Props:
 * - isOpen: Boolean to control visibility
 * - onClose: Callback when modal should close
 * - title: Modal header title
 * - children: Modal body content
 * - footer: Optional custom footer content
 */
export default function BaseModal({ isOpen, onClose, title, children, footer }) {
  if (!isOpen) return null;

  return (
    <div className="cd-modal-overlay" onClick={onClose}>
      <div className="cd-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cd-modal-header">
          <h2 className="cd-modal-title">{title}</h2>
          <button className="cd-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="cd-modal-body">
          {children}
        </div>
        {footer && (
          <div className="cd-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
